import styled from 'styled-components'

export const SalaryRejectionContainer = styled.div`
    padding: 32px;
    max-width: 586px;
    width: 100%;
    h1 {
      color: ${({theme}) => theme.accent};
      font-size: 19px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      letter-spacing: 0.4px;
      margin-bottom: 24px;
    }
    p {
      color: ${({theme}) => theme.grayDark};
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: 0.3px;
      margin-bottom: 24px;
    }
`

export const SalaryRejectionButtonContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: end;
    margin-top: 24px;
`
